import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { RoutesPage } from "../constants/routes";

export const useConsentData = () => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const consentNames = params.getAll("consentNames");
    const consentFiles = params.getAll("consentFiles");

    if (consentNames.length === 0) {
      consentNames.push("Terms of Service");
      consentFiles.push(
        `${window.location.origin}${RoutesPage.TermsOfService}`,
      );
      consentNames.push("Privacy Policy");
      consentFiles.push(`${window.location.origin}${RoutesPage.PrivacyPolicy}`);
    }

    return consentNames.map((title, index) => ({
      title,
      file: consentFiles[index] || "",
    }));
  }, [location.search]);
};
